import { styled, MenuItem } from "@mui/material";
import { display } from "@mui/system";

export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '48px  96px  ',
    minHeight: '75vh',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px  '
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px  24px  '
    },
    [theme.breakpoints.down('xs')]: {
        padding: '6px 12px  '
    }
}))
export const Filter = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    width: '700px',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'start',
        width: '100%',
    }
}))
export const FilterDrop = styled('div')(({ theme }) => (props) => ({
    width: '320px',
    [theme.breakpoints.down('sm')]: {
        width: '95%'
    }
}))
export const FilterMenu = styled(MenuItem)(({ theme }) => (props) => ({
    '&.Mui-selected': {
        backgroundColor: '#0056D2',
        color: '#fff'
    },
    color: '#333333',
    fontSize: '16px',
    fontWeight: '500'// Change this to the desired font size
}))
export const Card = styled('div')(({ theme }) => (props) => ({
    minWidth: '250px',
    minHeight: '300px',
    width: '300px',
    overflow: 'hidden',
    height: '300px',
    textAlign: 'right',
    padding: '34px',
    border: '2px solid #DDDDDD',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
        minWidth: '250px',
        minHeight: '320px',
        width: '250px',
        padding: ' 16px 16px 24px',

    },
}))
export const ImageCard = styled('div')(({ theme }) => (props) => ({
    maxWidth: '144px',
    maxHeight: '144px',
}))
export const Image = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
    borderRadius: '5px'
}))
export const TitleCard = styled('h6')(({ theme }) => (props) => ({
    fontSize: '18px',
    fontWeight: 800,
    lineHeight: '20px',
    letterSpacing: '0em',
    textAlign: 'center',
    width: '100%',
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    margin: '15px 0 8px',
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
        fontWeight: 500,
    },
}))
export const TitleDisc = styled('p')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0em',
    width: '100%',
    textAlign: 'left',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    margin: '0',
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        lineHeight: '1.5',

    },
}))
export const OldPrice = styled('p')(({ theme }) => (props) => ({
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '14px',
    color: 'rgba(50,50,50,0.5)',
    margin: '0',
    wordSpacing: '1.7'
}))
export const TitlePrice = styled('p')(({ theme }) => (props) => ({
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '14px',
    color: '#0056D2',
    margin: '0',
    wordSpacing: '1.7'
}))
export const SectionRate = styled('div')(({ theme }) => (props) => ({
    display: "Flex",
    alignItems: 'center',
    gap: '8px',
    marginTop: '16px',
    justifyContent: 'start',
    width: '100%'
}))
export const Packages = styled('div')(({ theme }) => (props) => ({
    position: 'absolute',
    top: '8px',
    right: '-20px',
    height: '27px',
    width: '130px',
    background: '#0045a8',
    rotate: '150deg',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}))

export const PackText = styled('div')(({ theme }) => (props) => ({
    color: '#fff',
    rotate: '172deg',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: '0'
}))
